export const SUCCESS_NOTIFICATION_TYPE = "success";
export const ERROR_NOTIFICATION_TYPE = "error";
export const INFO_NOTIFICATION_TYPE = "info";

const ICON_ALERT = "alert-circle";
const ICON_LOCK = "lock-closed";

export const NOTIFICATION_PROPS = {
  icon: ICON_ALERT,
  align: "top",
  color: "primary",
  background: "primary",
  transparent: false,
  boldText: true,
};

export const NOTIFICATION_PROPS_SHORT = {
  shortTextWidth: true,
  align: "start",
  direction: "column",
};

export const NOTIFICATION_PROPS_LOCK = {
  icon: ICON_LOCK,
};

export const NOTIFICATION_PROPS_ERROR = {
  icon: ICON_ALERT,
  align: "top",
  color: "error",
  background: "error",
  transparent: false,
};
